import { render, staticRenderFns } from "./TabFrame.vue?vue&type=template&id=154f04f6&"
import script from "./TabFrame.vue?vue&type=script&lang=ts&"
export * from "./TabFrame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports